import { FC } from "react";
import { useTranslation } from "react-i18next";
import { SolutionCardReadOnly } from "../../..";

interface IChoosenSolutionCardsStatistics {
    solutionCards: any[];
}

const ChoosenSolutionCardsStatistics: FC<IChoosenSolutionCardsStatistics> = (props) => {
    const { solutionCards } = props;

    const { t } = useTranslation();

    if(!solutionCards){
        return(<div> </div>);
    }

    const handleOnClickLearnMore = (tedTalkLink: string) => {
        window.location.href = tedTalkLink;
    }

    return(
      <div className="choosen_solution_cards_statistics_wrapper">
          {/* <div className="no_solution_cards"> {t("noSolutionCardsWereChosenText")} </div> */}
          {solutionCards?.map( (card: any, index: number) => {
              return(
                <div className="one_choosen_solution_cards_statistics" key={index}>
                     <div className="solution_card_read_only_wrapper_statistics"  >
                        <SolutionCardReadOnly cardData={card} paddingFromTopInVw={7} />
                    </div>
                    <div className="one_choosen_solution_cards_statistics_additional_text">
                        <div className="cloud_corner_arrow"></div>
                        <div className="solution_card_statistics_cloud">
                            <div className="solution_card_statistics_text">
                                {card.info}
                            </div>
                            {card?.type !== "Joker" && 
                            <div className="solution_card_statistics_link">
                                {
                                    card.urlForTedTalk && (
                                        <u onClick={() => handleOnClickLearnMore(card.urlForTedTalk)}> {t("clickToLearnMoreText")} </u>
                                    )
                                }
                            </div>
                            }
                        </div>
                    </div>
                </div>
                )
          } )}
      </div>)
}

export default ChoosenSolutionCardsStatistics;